export const ZOHO_OPPORTUNITY_BASE_PATH =
    "ms-sp-genera-oportunidad-zoho-pga/soporte-ti/zoho/v1";
export const ZOHO_PHASE_BASE_PATH = "ms-sp-actualiza-fase-zoho-pga/soporte-ti/zoho/v1";
